// extracted by mini-css-extract-plugin
export var productGrid = "ProductGrid-module--productGrid--fUCko";
export var filters = "ProductGrid-module--filters--3Yne1";
export var active = "ProductGrid-module--active--8PY83";